const VITE_OKTAORG_URI = import.meta.env.VITE_OKTAORG_URI as string
const VITE_MODE = import.meta.env.VITE_MODE as string
const VITE_AUTHORIZATION_SERVER = import.meta.env.VITE_AUTHORIZATION_SERVER as string
const VITE_OKTA_HOSTED_URI = import.meta.env.VITE_OKTA_HOSTED_URI as string
const VITE_OKTA_CLIENT_ID = import.meta.env.VITE_OKTA_CLIENT_ID as string
const VITE_PUBLIC_PATH = import.meta.env.VITE_PUBLIC_PATH as string
const NODE_ENV = import.meta.env.MODE as string
const VITE_CLOUDINARY_CLOUD = import.meta.env.VITE_CLOUDINARY_CLOUD as string

interface InjectedParams {
  nodeEnv?: string | false
  oktaOrgUrl?: string | false
  authorizationServer?: string | false
  oktaHostedUrl?: string | false
  clientId?: string | false,
  cloudinaryCloud?: string | false,
}

function getInjectedParams(): InjectedParams {
  const app = document.getElementsByTagName('body')[0]
  if (app && app.dataset.config) {
    const cfg = JSON.parse(app.dataset.config)
    return {
      nodeEnv: cfg.nodeEnv !== '%NODE_ENV%' ? cfg.nodeEnv : false,
      oktaOrgUrl: cfg.orgUrl !== '%OKTA_BASE_URI%' ? cfg.orgUrl : false,
      authorizationServer: cfg.authorizationServer !== '%OKTA_AUTHORIZATION_SERVER%' ? cfg.authorizationServer : false,
      oktaHostedUrl: cfg.oktaHostedUrl !== '%OKTA_HOSTED_URI%' ? cfg.oktaHostedUrl : false,
      clientId: cfg.clientId !== '%OKTA_CLIENT_ID%' ? cfg.clientId : false,
      cloudinaryCloud: cfg.cloudinaryCloud !== '%CLOUDINARY_CLOUD%' ? cfg.cloudinaryCloud : false
    }
  }
  return {}
}

const injectedParams = getInjectedParams()

export default {
  nodeEnv: (injectedParams.nodeEnv || VITE_MODE || NODE_ENV),
  oktaOrgUrl: (injectedParams.oktaOrgUrl || VITE_OKTAORG_URI),
  authorizationServer: (injectedParams.authorizationServer || VITE_AUTHORIZATION_SERVER),
  oktaHostedUrl: (injectedParams.oktaHostedUrl || VITE_OKTA_HOSTED_URI),
  clientId: (injectedParams.clientId || VITE_OKTA_CLIENT_ID),
  cloudinaryCloud: (injectedParams.cloudinaryCloud || VITE_CLOUDINARY_CLOUD),
  publicPath: VITE_PUBLIC_PATH,
  absolutePath: '',
  myMachinePath: VITE_PUBLIC_PATH,
  gtmKey: 'GTM-MX7G2BX',
  enigmaAppId: 29
}
